import { PPopover } from '@porsche-design-system/components-react';
import { type TooltipProps } from 'antd';

type AntdTooltipPlacement = TooltipProps['placement'];

const placementMap: Record<AntdTooltipPlacement, 'top' | 'bottom' | 'left' | 'right'> = {
    top: 'top',
    topLeft: 'top',
    topRight: 'top',
    bottom: 'bottom',
    bottomLeft: 'bottom',
    bottomRight: 'bottom',
    left: 'left',
    leftTop: 'left',
    leftBottom: 'left',
    right: 'right',
    rightTop: 'right',
    rightBottom: 'right',
};

const Tooltip = ({ children, title, placement = 'bottom' }: TooltipProps) => (
    <PPopover direction={placementMap[placement]}>
        <>
            <span slot="description">{children}</span>
            {title}
        </>
    </PPopover>
);

export default Tooltip;
